import React from 'react';
import Navbar from './Navbar'
import { Container } from 'reactstrap';
import { useHistory } from "react-router-dom";
import '../assests/css/qrcode.css'
import qrcode from "../assests/images/QRCode.png"
import IdleMonitor from './userAutoLogout'; //session management
import moment from 'moment';
const Qrcode = () => {
    const history = useHistory();

    return (
        <div className="mpmaindiv1" style={{ fontFamily: "Poppins" }}>
            <div style={{ width: "100%", height: "100vh" }}>
                <Navbar />
                <Container fluid="true" className="py-auto qrmaincontainer" style={{ paddingTop: "4rem" }}>
                    <div className="qrinnerdiv" style={{ height: `${window.innerHeight - 58}px` }}>
                        <div className="bg-white mx-auto contentDiv">
                            <h5 style={{ color: "#2596BE", textAlign: "center" }}>Scan the Code to Download the Application</h5>
                            <div style={{ textAlign: "center", /*padding: "1rem"*/ }}><img src={qrcode} alt="qrcode" className="app-qrcode" /></div>
                            <div className="px-auto listview">
                                <span style={{ fontWeight: "400", fontSize: "large", color: "#3A3838" }}>To Download the Application -</span>

                                <ol type="1" style={{ paddingLeft: "1rem" }}>
                                    <li>Open camera in your phone</li>
                                    <li>Scan the code.</li>
                                    <li>Install the application from the Play Store/App Store.</li>
                                </ol>
                            </div>
                            <div style={{ color: "#2596BE", textAlign: "center" }} onClick={() => {
                                localStorage.setItem('start-date', moment().startOf('month').format('MM/DD/YYYY'))
                                localStorage.setItem('end-date', moment().endOf('day').format('MM/DD/YYYY'))
                                // localStorage.setItem('start-date', moment().startOf('month').subtract(6, 'months').format('MM/DD/YYYY'))
                                // localStorage.setItem('end-date', moment().endOf("day").format('MM/DD/YYYY'))
                                var userId = localStorage.getItem('userId')
                                localStorage.setItem('userId', JSON.stringify(userId));
                                var email = localStorage.getItem('email')
                                localStorage.setItem('email', JSON.stringify(email));
                                var sToken = localStorage.getItem('sToken')
                                localStorage.setItem('sToken', JSON.stringify(sToken));

                                history.push("/dashboard")

                            }}><b style={{ cursor: "pointer" }}>Skip For Now</b></div>
                        </div>
                    </div>
                </Container>
            </div>
            <IdleMonitor />
        </div>
    )
}

export default Qrcode;